import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cOrgList from './cOrgList';

export default class iOrgList extends cOrgList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }
    
  $id_stgs = {
  };

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={(bf.i(global.c?.state.sgc_pageRole, ['adm1', 'own2'])) ? true : false}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iOrgDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        d_hdrs={{
          pfx: iv._get_hdrPfx('部門一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
            ld_iss: [
              ip.$dd_subMenuss['部門CSV出力'],
              ip.$dd_subMenuss['部門運営者CSV出力'],
              ip.$dd_subMenuss['部門CSV取込'],
              ip.$dd_subMenuss['部門運営者CSV取込'],
            ],
          }
        }}
        n_bdyW={ic.gn_w}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm30ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iOrgDtl',
              pagePntKeyName: 'cm30_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
              {
                type: 'Msg',
                b_vsb: (bf.f(global.c?.state.sld_cm30ss) == false) ? true : false,
                pfx: '設定可能な部門がありません',
              }
          ],
        }}
      />
    );
  }
};

